	 <h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            <esl-message-toast [(message)]="error"></esl-message-toast>
            </div>
         <!--Laboratory form  -->
         <div class="ui form" [formGroup]="projectForm">

				<!-- <div class="field" [ngClass]="displayFieldCss('project_name')">
                              <label>Department Name</label>
							 Department 1
				</div>
				 <div class="field" [ngClass]="displayFieldCss('description')">
                              <label> Description</label>
						Description
                        </div> -->
       <div fxLayout="row" fxLayoutAlign='space-between center'>
            <h3 appMargin marginB="0" class="ui primary header">Group</h3>
            <button class="ui tiny icon button" (click)="addGroup()">
                  <i class="plus icon"></i>
                  </button>
            </div>

                  <hr>
                  <div class="ui secondary segment"
                         fxLayoutAlign='space-between center'
                         fxLayout="row" *ngFor="let unit of groups">
                        <div fxFlex>{{unit.name}}</div>
                        <div fxFlex class="text-right">
                        <button class="ui tiny circular icon button" (click)="removeGroup(unit)"><i class="trash icon"></i></button>
                        <button class="ui tiny circular icon button" (click)="editGroup(unit)"><i class="pencil icon"></i></button>
                        </div>
                  </div>



    </div>

 </div>
 </div>

      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done </button>

      </div>


